import { DefaultNamespace, TFunction } from 'i18next'
import { z } from 'zod'

import { alphanumericRegex, phoneRegex } from '~/validation/regex'

type Profile = {
  name: string
  englishName?: string
  language: number
  phoneNumber?: string
  mobileNumber?: string
}

export const profileEditSchema = (
  t: TFunction<DefaultNamespace, undefined>,
): z.ZodSchema<Profile> =>
  z.object({
    name: z.string().min(1, {
      message: t('message.required', {
        entity: t('pages.members.label.name'),
      }),
    }),
    englishName: z
      .string()
      .max(128, {
        message: t('message.max_length', {
          entity: t('pages.members.label.englishName'),
          length: 128,
        }),
      })
      .refine(
        (val) => alphanumericRegex.test(val),
        t('message.alphanumeric', {
          entity: t('pages.members.label.englishName'),
        }) ?? '',
      )
      .optional(),
    language: z.coerce.number(),
    phoneNumber: z
      .string()
      .optional()
      .refine(
        (val) => val === undefined || val === '' || phoneRegex.test(val),
        t('message.invalidPhoneNumber') ?? '',
      ),
    mobileNumber: z
      .string()
      .optional()
      .refine(
        (val) => val === undefined || val === '' || phoneRegex.test(val),
        t('message.invalidPhoneNumber') ?? '',
      ),
  }) satisfies z.ZodSchema<Profile>

export type ProfileEditSchema = z.infer<ReturnType<typeof profileEditSchema>>
